import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/innovaciones-en-atmp-estado-de-la-industria-en-2024")({
  head: () => buildRouteHead("/es/innovaciones-en-atmp-estado-de-la-industria-en-2024", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/downloads", replace: true });
  },
});
